import RecapTagPills from "./RecapTagPills";
import "./v2-question-surface.css";

export default function RecapCard({
  label,
  answer,
  tags,
  skipped = false,
  editLabel = "Edit",
  editAriaLabel,
  onEdit,
}) {
  return (
    <article className="tgc-v2-recap-card">
      <div className="tgc-v2-recap-card__topline">
        <h2 className="tgc-v2-recap-card__label">{label}</h2>
        <button className="tgc-v2-recap-card__edit" type="button" aria-label={editAriaLabel} onClick={onEdit}>
          {editLabel}
        </button>
      </div>
      <div className={skipped ? "tgc-v2-recap-card__answer tgc-v2-recap-card__answer--skipped" : "tgc-v2-recap-card__answer"}>
        {tags ? <RecapTagPills values={tags} /> : skipped ? "Skipped" : answer}
      </div>
    </article>
  );
}
